<template>
  <div class="filter-province-box">
    <div class="filter-province" @click="selectProvinceDialog.visible = true">
      <img
        class="location-img"
        src="../../../../../../assets/imgs/work-wx/country/icon-location-2.png"
      />
      <div class="location-text">
        {{ areaText }}-
        <div class="province-code">{{ provinces[inner_province_code] }}</div>
      </div>
      <img
        class="down-triangle"
        src="../../../../../../assets/imgs/work-wx/country/icon-down-gray.png"
      />
    </div>
    <base-dialog
      :visible.sync="selectProvinceDialog.visible"
      :title="'选择' + areaText"
      :hide-footer="true"
    >
      <div class="province-box">
        <div
          class="province-item"
          :class="{ active: +key === inner_province_code }"
          v-for="(value, key) in provinces"
          :key="key"
          @click="changeProvinceCode(+key)"
        >
          {{ value }}
        </div>
      </div>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/pages/work-wx/components/base-dialog.vue';
import pcdService from '@/services/pcdService';

export default {
  components: {
    BaseDialog,
  },
  props: {
    province_code: Number,
    countryInfo: Object,
  },
  data() {
    return {
      provinces: {},
      selectProvinceDialog: {
        visible: false,
      },
    };
  },
  computed: {
    inner_province_code: {
      get() {
        return this.province_code;
      },
      set(value) {
        this.$emit('update:province_code', value);
      },
    },
    areaText() {
      return ['常住地', '护照签发地', '户籍所在地'][this.countryInfo.area];
    },
  },
  created() {
    this.getPcdsAndProvinces();
  },
  methods: {
    getPcdsAndProvinces() {
      pcdService.getPcd(this.$http).then((pcds) => {
        this.provinces = pcds[86];
      });
    },
    changeProvinceCode(code) {
      this.inner_province_code = code;
      this.selectProvinceDialog.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.filter-province-box {
  flex-shrink: 0;
  .filter-province {
    flex-shrink: 0;
    height: 16px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    border-right: 1px solid #e9eef2;
    .location-img {
      width: 12px;
      margin-right: 6px;
    }
    .location-text {
      color: #444;
      font-size: 14px;
      display: flex;
      align-items: center;
    }
    .down-triangle {
      width: 16px;
      height: 16px;
    }
  }
  .province-box {
    display: flex;
    flex-wrap: wrap;
    margin-right: -20px;
    margin-bottom: -20px;
    .province-item {
      width: 50px;
      flex-shrink: 0;
      margin-right: 20px;
      margin-bottom: 20px;
      color: #2c3344;
      font-size: 14px;
      cursor: pointer;
      &:hover,
      &.active {
        color: #3fa2f5;
      }
    }
  }
}
</style>
